import { render, staticRenderFns } from "./ModalItem.vue?vue&type=template&id=76509843&"
import script from "./ModalItem.vue?vue&type=script&lang=ts&"
export * from "./ModalItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports